import { createReducer } from 'redux-act';
import * as actions from '#app/actions/valuation';
import type { ValuationFormPayload } from '#app/actions/valuation';

export interface ValuationState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: ValuationState = {
  modalVisible: false,
  form: {},
};

const setValuationModalVisible = (state: ValuationState, bool: boolean): ValuationState => ({
  ...state,
  modalVisible: bool,
});

const setValuationForm = (state: ValuationState, form: ValuationFormPayload): ValuationState => ({
  ...state,
  form: form ?? {},
});

export default createReducer<ValuationState>(
  {
    [actions.setValuationModalVisible.getType()]: setValuationModalVisible,
    [actions.setValuationForm.getType()]: setValuationForm,
  },
  initialState
);
